import Api from "@/services/api";
import { TimeZone } from "@/services/timeZones/types";

export async function getTimeZones(): Promise<Array<TimeZone>> {
    return new Promise((resolve, reject) => {
        Api.post("/timeZone", new Date()).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};
